import { Frame, FrameTitle, SubTitle, Title, SubmitScore, Timer, Button } from 'Pages/HazardPerceptionGame/Components';

const GameOver = ({ setScreen, score }) => {
    return (
        <div className="w-full h-full flex justify-center items-center">
            <Frame>
                <div
                    className="bg-white bg-opacity-10 rounded-xl px-8 flex items-center justify-center text-center flex-col py-4 lg:py-12 xl:py-24"
                >
                    <FrameTitle>
                        CAM 1
                    </FrameTitle>

                    <Title>WELL PLAYED!</Title>
                    <SubTitle>GAME OVER</SubTitle>

                    <div className="flex flex-row items-stretch lg:w-4/5 mt-2 lg:mt-10 xl:mt-20 gap-3 lg:gap-6">
                        <div className="w-1/2 bg-white bg-opacity-10 rounded-xl text-xs lg:text-xl rubrik-regular text-left p-3 lg:p-6 flex flex-col items-center">
                            <p className="text-center mb-4">
                                {score > 0 ? (
                                    <>Congrats! You completed all levels with plenty of time left on the clock.</>
                                ) : (
                                    <>Better luck next time! You didn't find all of the hazards. Why not try again?</>
                                )}
                            </p>
                            <Timer
                                running={false}
                                time={score}
                            />
                        </div>

                        <div className="w-1/2 rubrik-regular flex justify-center items-center text-center">
                            <Button
                                onClick={() => setScreen('how-to-play')}
                                size="small"
                            >
                                Play Again
                            </Button>
                        </div>
                    </div>
                </div>
            </Frame>
        </div>
    );
};

export default GameOver;
